import { PanelType } from './Constants';

export const isPanelType = (panelName) => {
  const panelCurrent = process.env.REACT_APP_PANEL_TYPE || PanelType.DIRECTA;
  return panelCurrent === panelName;
};

export const isTupayPanel = isPanelType(PanelType.TUPAY);

export const isLimePayPanel = isPanelType(PanelType.LIME_PAY);

export const isOneKeyPaymentsPanel = isPanelType(PanelType.ONEKEY_PAYMENTS);

export const isD24Panel = isPanelType(PanelType.DIRECTA);

export const isZimoPanel = isPanelType(PanelType.ZIMO);

export const getFAQChargebackstrings = () => {
  const defaultFAQStrings = {
    faqTitle1: 'faqsChargebacksQ1',
    faqDetails1: 'faqsChargebacksA1',
    faqTitle2: 'faqsChargebacksDetails',
    faqDetails2Items: [
      'faqsChargebacksDetails1',
      'faqsChargebacksDetails2',
      'faqsChargebacksDetails3',
      'faqsChargebacksDetails4',
      'faqsChargebacksDetails5',
      'faqsChargebacksDetails6',
      'faqsChargebacksDetails7',
      'faqsChargebacksDetails8',
    ],
    faqDetails21: 'faqsChargebacksA2',
  };

  if (isTupayPanel) {
    return {
      ...defaultFAQStrings,
      faqTitle1: 'faqsTupayChargebacksQ1',
      faqDetails1: 'faqsTupayChargebacksA1',
    };
  }

  return defaultFAQStrings;
};

export const getFAQSupportStrings = () => {
  const defaultFAQStrings = {
    faqItems: [
      {
        title: 'faqsSupportQ1',
        details: 'faqsSupportA1',
      },
      {
        title: 'faqsSupportQ2',
        details: 'faqsSupportA2.1',
      },
      {
        title: 'faqsSupportA2.2',
        subtitle: 'faqsSupportA2Steps',
        details: ['faqsSupportA2.3', 'faqsSupportA2.4', 'faqsSupportA2.5', 'faqsSupportA2.6'],
      },
      {
        title: 'faqsSupportQ3',
        subtitle: 'faqsSupportA2Steps',
        details: ['faqsSupportA3.1', 'faqsSupportA3.2', 'faqsSupportA3.3', 'faqsSupportA3.4'],
      },
      {
        title: 'faqsSupportQ4',
        subtitle: 'faqsSupportA2Steps',
        details: ['faqsSupportA4.1', 'faqsSupportA4.2', 'faqsSupportA4.3', 'faqsSupportA4.4'],
      },
      {
        title: 'faqsSupportQ5',
        subtitle: 'faqsSupportA2Steps',
        details: ['faqsSupportA5.1', 'faqsSupportA5.2', 'faqsSupportA5.3', 'faqsSupportA5.4'],
      },
      {
        title: 'faqsSupportQ6',
        details: 'faqsSupportA6',
      },
      {
        title: 'faqsSupportQ7',
        subtitle: 'faqsSupportA7',
        details: ['faqsSupportA7.1', 'faqsSupportA7.2', 'faqsSupportA7.3'],
      },
    ],
  };

  if (isTupayPanel) {
    defaultFAQStrings.faqItems[0].details = 'faqsTupaySupportA1';
    defaultFAQStrings.faqItems[7].subtitle = 'faqsTupaySupportA7';
  }
  return defaultFAQStrings;
};
